import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "src/components/Shared/NewForms/NFLookupDivision";
import { NFLookupWarehouse } from "src/components/Shared/NewForms/NFLookupWarehouse";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const PostingOfGoodsDetailMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document #")} fieldName={"documentNumber"} disabled={true} />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} required={true} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} required={true} />
        </Col>
        <Col sm={6}>
          <NFLookupWarehouse fieldName={"warehouseId"} title={t("Warehouse")} required={true} companyId={watch("companyId")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupDivision fieldName={"divisionId"} title={t("Division")} companyId={watch("companyId")} required={true} />
        </Col>
      </Row>
    </>
  );
};
